import { gql, TypedDocumentNode } from '@apollo/client';
import type { InventoryItem } from '../models/InventoryItem';

export const ADD_INVENTORYITEM_MUTATION: TypedDocumentNode<{ added: boolean }, { input: InventoryItem }> = gql`
  mutation AddInventoryItem($input: InventoryItemModelInput!) {
    added: addInventoryItem(input: $input)
  }
`;

export const UPDATE_INVENTORYITEM_MUTATION: TypedDocumentNode<{ updatedInventoryItem: InventoryItem }, { id: number, input: { id: number, costPerUnit: number, quantityOnHand: number | undefined, lotNumber: string | undefined, surchargePerUnit: number | undefined, shippingCostPerUnit: number | undefined, surchargeOrDiscount: number | undefined, orderDetails: string | undefined } }> = gql`
  mutation UpdateInventoryItem($id: Int!, $input: InventoryItemModelInput!) {
    updatedInventoryItem: updateInventoryItem(id: $id, input: $input) {
      id,
      quantityOnHand,
      quantityOrdered,
      itemId,
      vendorId,
      purchaseOrderId
    }
  }
`;

export const DELETE_INVENTORYITEM_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteInventoryItemById($id: Int!) {
    deleted: deleteInventoryItemById(id: $id)
  }
`;

